import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiClientService } from 'api-services';
import { BehaviorSubject, catchError, map, Observable, finalize } from 'rxjs';
import { AuthService, SharedService } from 'services';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LicenseRenewalService {
  constructor(
    private apiClient: ApiClientService,
    private authService: AuthService,
    private http: HttpClient,
    private sharedService: SharedService
  ) { }

  public licenseRenewalRequest: BehaviorSubject<any> = new BehaviorSubject(true);

  // Add Appointer API
  public getLicenseRenewalAppointer(id: number, tenantId: number) {
    return this.apiClient.get(`api/LicenseRenewalRequest/getLicenseRenewalAppointer/${tenantId}/${id}`, null, null, true);
  }

  public getPaymentType() {
    return this.apiClient.get(`api/LicenseRenewalRequest/getPaymentType`, null, null, false);
  }

  public updateAppointerInfo(appointerInfor: any) {
    return this.apiClient.post(`api/LicenseRenewalRequest/insertUpdateLicenseRenewalAppointer`, appointerInfor, null, true);
  }

  //
  getUserLicenseDetails(userLicenseClassId: number, userId: number, tenantId: number) {
    return this.apiClient.get(`api/LicenseRenewalRequest/userLicenseDetails/${userLicenseClassId}/${userId}/${tenantId}`, null, null, true);
  }

  submitUserLicenseRenewalDetails(requestObj: any) {
    return this.apiClient.post(`api/LicenseRenewalRequest/createProducerLicenseRenewalRequest`, requestObj, null, true);
  }

  checkIfLicenseRenewalRequestActive(userLicenseClassId: number, userId: number, tenantId: number) {
    return this.apiClient.get(`api/LicenseRenewalRequest/checkLicenseRenewalRequestActive/${userLicenseClassId}/${userId}/${tenantId}`, null, null, true);
  }

  // getMyLicenseRenewalRequestList(searchLicenseModel: any) {
  //   return this.apiClient.post(`api/LicenseRenewalRequest/MyLicenseRenewalRequestList`, searchLicenseModel, null, true);
  // }
  getMyLicenseRenewalRequestList(searchLicenseModel: any) {
    return this.apiClient.post(`api/LicenseRenewalRequest/getAllLicenseRequests`, searchLicenseModel, null, true);
  }

  getPendingLicenseRequests(searchLicenseModel: any) {
    return this.apiClient.post(`api/LicenseRenewalRequest/getPendingLicenseRequests`, searchLicenseModel, null, false);
  }


  // getMyLicenseRenewalRequestDetails(userId: number, tenantId: number, userLicenseClassId: number, licenseRenewalRequestId: number) {
  //   return this.apiClient.get(`api/LicenseRenewalRequest/MyLicenseRenewalRequestDetails/${userId}/${tenantId}/${userLicenseClassId}/${licenseRenewalRequestId}`, null, null, false);
  // }

  getMyLicenseRenewalRequestDetails(userId: number, tenantId: number, userLicenseClassId: number, licenseRenewalRequestId: number, requestType:string) {
    return this.apiClient.get(`api/LicenseRenewalRequest/getLicenseRequestDetails/${userId}/${tenantId}/${userLicenseClassId}/${licenseRenewalRequestId}/${requestType}`, null, null, false);
  }

  // GetLicenseRenewalActivityLog(userId: number, tenantId: number, userLicenseClassId: number, licenseRenewalRequestId: number) {
  //   return this.apiClient.get(`api/LicenseRenewalRequest/MyLicenseRenewalRequestActivityLog/${userId}/${tenantId}/${userLicenseClassId}/${licenseRenewalRequestId}`, null, null, false);
  // }

  GetLicenseRenewalActivityLog(userId: number, tenantId: number, userLicenseClassId: number, licenseRenewalRequestId: number, requestType:string) {
    return this.apiClient.get(`api/LicenseRenewalRequest/getLicenseRequestActivityLog/${userId}/${tenantId}/${userLicenseClassId}/${licenseRenewalRequestId}/${requestType}`, null, null, false);
  }

  // logActivity(activity: any) {
  //   return this.apiClient.post(`api/LicenseRenewalRequest/logActivity`, activity, null, true);
  // }
  logActivity(activity: any) {
    return this.apiClient.post(`api/LicenseRenewalRequest/logLicenseActivity`, activity, null, true);
  }

  getLicenseRenewalApplicantDetails(userId: number, tenantId: number, userLicenseClassId: number) {
    return this.apiClient.get(`api/LicenseRenewalRequest/LicenseRenewalApplicantDetails/${userId}/${tenantId}/${userLicenseClassId}`, null, null, false);
  }

  checkEligibilityresponse(userId: number, tenantId: number, userLicenseClassId: number, licenseTransactionType: number, userType:string) {
    return this.apiClient.get(`api/LicenseRenewalRequest/eligibilityresponse/${tenantId}/${userId}/${userLicenseClassId}/${licenseTransactionType}/${userType}`, null, null, false);
  }

  getFirmOwnerAndRespProducerList(tenantId: number, stateId: number, branchId: number) {
    return this.apiClient.get(`api/LicenseRenewalRequest/GetFirmOwnerAndRespProducerForRenewal/${tenantId}/${stateId}/${branchId}`, null, null, true);
  }

  // shared data comopnent to component
  public licenseRenewalRequestObj(data: any) { //the component that wants to update something, calls this fn
    this.licenseRenewalRequest.next(data); //next() will feed the value in Subject
  }

  submitLicenseRenewal(licenseRenewalObj: any) {
    //return this.apiClient.post(`api/LicenseRenewalRequest/updateProducerLicenseRenewalRequest`, licenseRenewalObj, null, true) //LV commented on 10/29/2025
    return this.apiClient.post(`api/LicenseRenewalRequest/updateProducerLicenseRenewalRequestForWeb`, licenseRenewalObj, null, true)
  }

  // getAdminLicenseRenewalRequestList(searchLicenseModel: any) {
  //   return this.apiClient.post(`api/LicenseRenewalRequest/MyLicenseRenewalRequestList`, searchLicenseModel, null, true);
  // }
  getAdminLicenseRenewalRequestList(searchLicenseModel: any) {
    return this.apiClient.post(`api/LicenseRenewalRequest/getAllLicenseRequests`, searchLicenseModel, null, true);
  }

  submitAdminProcessLicenseRenewal(licenseRenewalObj: any) {
    return this.apiClient.post(`api/LicenseRenewalRequest/createAdminLicenseRenewalRequest`, licenseRenewalObj, null, true)
  }

  getLicenseRenewalStatus() {
    return this.apiClient.get(`api/LicenseRenewalRequest/licenseRenewalStatus`, null, null, true)
  }

  getResidenceTypes() {
    return this.apiClient.get(`api/LicenseRenewalRequest/residenceType`, null, null, true)
  }

  getBGQNonBGQ(type, tenantId) {
    return this.apiClient.get(`api/LicenseRenewalRequest/renewal-questionnaire/${type}/${tenantId}`, null, null, true)
  }

  // Bulk renewal API

  bulkEligibilityResponse(reqstParam) {
    return this.apiClient.post(`api/LicenseRenewalRequest/bulkEligibilityResponse`, reqstParam, null, false);
  }

  createBulkLicenseRenewalRequests(reqstParam) {
    return this.apiClient.post(`api/LicenseRenewalRequest/createBulkLicenseRenewalRequests`, reqstParam, null, true);
  }

  submitBulkLicenseRenewal(licenseRenewalObj: any) {
    return this.apiClient.post(`api/LicenseRenewalRequest/createBulkLicenseRenewalRequest`, licenseRenewalObj, null, false)
  }

  createBatch(batch: any) {
    return this.apiClient.post(`api/LicenseRenewalRequest/createBatch`, batch, null, true)
  }

  //Upload license Renewal files
  public UploadLicenseRenewalFile(formData: FormData): Observable<any> {
    const headers = new HttpHeaders().append(
      "Content-Disposition",
      "multipart/form-data"
    );
    this.sharedService.showLoader();
    return this.http
      .post(environment.baseUrl + `api/LicenseRenewalRequest/insertTransactionSnapshotFile`, formData, {
        headers: headers,
        reportProgress: false,
      })
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((err) => {
          return this.apiClient.handleError(err);
        }),
        finalize(() => {
          this.apiClient.hideLoader();
        })
      );

    // return this.http.post(environment.baseUrl + `api/LicenseRenewalRequest/insertTransactionSnapshotFile`, formData, {
    //   headers: headers,
    //   reportProgress: false,
    // });
  }

  public DownloadLicenseRenewalFile(transactionSnapshotFileId) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/octet-stream',
      })
    };

    return this.http.get(environment.baseUrl + `api/LicenseRenewalRequest/getTransactionSnapshotFile/${transactionSnapshotFileId}`, httpOptions)
      .pipe(map((response: any) => {
        let data = response;
        return data;
      }
      ));
  }

  //Firm License Renewal
  submitFirmLicenseRenewal(licenseRenewalObj: any) {
    return this.apiClient.post(`api/LicenseRenewalRequest/createFirmLicenseRenewalRequest`, licenseRenewalObj, null, true)
  }
  generateRequestPDF(renewalLicenseRequestDetails: any) {
    return this.apiClient.post(`api/LicenseRenewalRequest/GenerateRequestRenewalPDF`, renewalLicenseRequestDetails, null, true)
  }
  bulkgenerateRequestPDF(renewalLicenseRequestDetails: any) {
    return this.apiClient.post(`api/LicenseRenewalRequest/BulkGenerateRequestRenewalPDF`, renewalLicenseRequestDetails, null, true)
  }

  calculateUserLicenseEstimatedFee(requestObj: any, showLoading:boolean = false) {
    return this.apiClient.post(`api/FeeRequest/GetEstimatedFee`, requestObj, null, showLoading);
  }
  getRenewalNASDCRDStates(tenantId) {
    return this.apiClient.get(`api/LicenseRenewalRequest/GetRenewalNASD_CRDStates/${tenantId}`, null, null, true)
  }
  public getAllNIPRCountry(): Observable<any> {
    return this.apiClient.get('api/NewLicenseRequest/getAllNIPRCountry');
  }

  createBulkRenewalRequestProducer(listNewLicenseRequest: any) {
    return this.apiClient.post('api/LicenseRenewalRequest/createBulkRenewalRequestProducer', listNewLicenseRequest, null, true);
  }

  getProducerAwaitingRequestCount(userId: number) {
    return this.apiClient.get(`api/LicenseRenewalRequest/getProducerAwaitingRequestCount/${userId}`, null, null, false);
  }
}
